import { api } from "assets/scripts/utilities/api-clients";

export const autoGenerate = async (debitNote) => {
  try {
    const { _id, number } = debitNote;

    const response = await api.put("/account/debitnotes/auto-generate", {
      _id,
      dn_number: number || "DN/" + debitNote?.bill_number || "",
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const cancel = async (params) => {
  const { debitNote, removeFiles, path = "kam" } = params;

  const endpoints = {
    kam: {
      debitNote: {
        cancel: "/kam/debitnotes/cancel",
      },
    },
    account: {
      debitNote: {
        cancel: "/account/debitnotes/cancel",
      },
    },
  };

  const response = await api.put(endpoints[path].debitNote.cancel, {
    _id: debitNote._id,
    reason: debitNote.reason,
    isFilesToBeRemoved: removeFiles,
  });

  return response;
};

export const get = async (id, source) => {
  const url = {
    kam: `/kam/debitnotes/${id}`,
    sales: `/sales/debit-note/${id}`,
    purchases: `/purchase/debit-note/${id}`,
  };
  const response = await api.get(url[source]);

  return response;
};

export const index = async (options = {}) => {
  const { source = "kam", ...rest } = options;
  const url = {
    sales: "/sales/debit-notes",
    kam: "/kam/debitnotes",
    purchases: "/purchase/debit-notes",
  };
  const response = await api.get(url[source], rest);

  return response;
};

export const post = async (user) => {
  const response = await api.post("/kam/debitnotes", user);

  return response;
};

export const put = async (
  user,
  options = {
    params: {
      showMessage: false,
    },
  },
) => {
  const response = await api.put("/account/debitnotes", user, options);

  return response;
};

export const checkNumber = async (number) => {
  const response = await api.put("/account/debitnotes/number", number);

  return response;
};

export const getFromPB = async (pbId) => {
  const response = await api.get(`/accounts/debitnotes/${pbId}`);

  return response;
};
